export const EXCLUDED_AUTHORIZATION_TOKEN_ENDPOINTS = ['refresh_token'];

export const ENDPOINTS_WITH_CASDOOR_TOKEN = ['getTeachbaseAuthData', 'generateTeachbaseAuthLink'];
